import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  page: {
    backgroundColor: 'var(--grey-100)',
    p: { xs: '16px', md: '24px' },
    borderRadius: '12px'
  } satisfies SxProps<Theme>,
  intro: {
    mb: '16px',
    maxWidth: '760px'
  } satisfies SxProps<Theme>,
  notice: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: 'var(--blue-500)',
    color: 'var(--white)',
    borderRadius: '8px',
    px: '16px',
    py: '12px',
    mb: '20px'
  } satisfies SxProps<Theme>,
  noticeText: {
    flexGrow: 1,
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  noticeDismiss: {
    color: 'var(--white)'
  } satisfies SxProps<Theme>,
  panel: {
    p: '20px',
    borderRadius: '8px',
    backgroundColor: 'var(--white)',
    flex: 1,
    minWidth: 0
  } satisfies SxProps<Theme>,
  sendButton: {
    textTransform: 'none',
    mt: '12px'
  } satisfies SxProps<Theme>,
  headCell: {
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    fontWeight: 700,
    color: 'text.secondary',
    letterSpacing: '0.04em'
  } satisfies SxProps<Theme>
}
